import { NgClass } from '@angular/common'
import { Component, computed, input } from '@angular/core'
import { RouterLink, UrlTree } from '@angular/router'
import { HtmlAttributesDirective } from 'src/app/shared/directives/html-attributes.directive'

@Component({
    selector: 'sf-sidebar-brand',
    imports: [RouterLink, HtmlAttributesDirective, NgClass],
    templateUrl: './sidebar-brand.component.html',
    host: {
        class: 'sidebar-brand',
    },
})
export class SidebarBrandComponent {
    readonly brandFull = input<any>()
    readonly brandNarrow = input<any>()

    readonly routerLink = input<string | any[] | UrlTree | null | undefined>()

    readonly brandImg = computed(() => Boolean(this.brandFull() || this.brandNarrow()))
}
